import i18n from "../../i18n";

export const state = {
  layoutType: "vertical",
  layoutWidth: "fluid",
  leftSidebarType: "dark",
  topbar: "dark",
  loader: false,
  lang: "en",
};

export const getters = {
  lang(state) {
    return state.lang;
  },
};
export const mutations = {
  CHANGE_LAYOUT(state, layoutType) {
    state.layoutType = layoutType;
  },
  CHANGE_LAYOUT_WIDTH(state, layoutWidth) {
    state.layoutWidth = layoutWidth;
  },
  CHANGE_LEFT_SIDEBAR_TYPE(state, leftSidebarType) {
    state.leftSidebarType = leftSidebarType;
  },
  CHANGE_TOPBAR(state, topbar) {
    state.topbar = topbar;
  },
  LOADER(state, loader) {
    state.loader = loader;
  },
  CHANGE_LANG(state, lang) {
    i18n.locale = lang;
    const bootstrapRtlStyleId = "bootstrap-style";
    const appRtlStyleId = "app-style";
    if (["ar"].includes(lang)) {
      document.documentElement.setAttribute("dir", "rtl");
      document
        .getElementById(appRtlStyleId)
        .setAttribute("href", "/css/app-rtl.min.css");
      document
        .getElementById(bootstrapRtlStyleId)
        .setAttribute("href", "/css/bootstrap-rtl.min.css");
    } else {
      document.documentElement.setAttribute("dir", "ltr");
      document.getElementById(appRtlStyleId).removeAttribute("href");
      document.getElementById(bootstrapRtlStyleId).removeAttribute("href");
    }

    console.log("test", document.getElementById(bootstrapRtlStyleId));
    state.lang = lang;
  },
};

export const actions = {
  changeLayoutType({ commit }, { layoutType }) {
    commit("CHANGE_LAYOUT", layoutType);
  },

  changeLayoutWidth({ commit }, { layoutWidth }) {
    commit("CHANGE_LAYOUT_WIDTH", layoutWidth);
  },

  changeLeftSidebarType({ commit }, { leftSidebarType }) {
    commit("CHANGE_LEFT_SIDEBAR_TYPE", leftSidebarType);
  },

  changeTopbar({ commit }, { topbar }) {
    commit("CHANGE_TOPBAR", topbar);
  },

  changeLoaderValue({ commit }, { loader }) {
    commit("LOADER", loader);
  },
};
